module.exports = __webpack_public_path__ + "img/new4-img1.6877afb7.png";